import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import PostHeader from './PostHeader';
import PostActions from './PostActions';

function FeedPost({ post }) {
  const {
    puzzleId,
    user,
    imageUrl,
    caption,
    likeCount,
    commentCount,
    timestamp,
    isLiked,
    isBookmarked,
    gridSize,
  } = post;

  return (
    <article className="bg-puzzle-surface border border-puzzle-border rounded-lg mb-4">
      {/* Post header */}
      <PostHeader user={user} timestamp={timestamp} />

      {/* Post image - clickable to play puzzle */}
      <Link to={`/play/${puzzleId}`} className="block">
        <div className="aspect-square bg-gray-100 relative">
          <img
            src={imageUrl}
            alt={`Puzzle by ${user.username}`}
            className="w-full h-full object-cover"
          />
          {/* Grid size badge */}
          {gridSize && (
            <div className="absolute bottom-3 right-3 bg-black/60 text-white text-xs px-2 py-1 rounded">
              {gridSize}
            </div>
          )}
        </div>
      </Link>

      {/* Action buttons */}
      <PostActions isLiked={isLiked} isBookmarked={isBookmarked} />

      {/* Post content */}
      <div className="px-3 pb-3">
        {/* Like count */}
        <p className="font-semibold text-sm text-puzzle-text mb-1">
          {likeCount.toLocaleString()}
          {' '}
          likes
        </p>

        {/* Caption */}
        <p className="text-sm text-puzzle-text">
          <span className="font-semibold">{user.username}</span>
          {' '}
          {caption}
        </p>

        {/* View comments link */}
        {commentCount > 0 && (
          <button
            type="button"
            className="text-puzzle-text-secondary text-sm mt-1 hover:opacity-70 transition-opacity"
          >
            {`View all ${commentCount} comments`}
          </button>
        )}
      </div>
    </article>
  );
}

FeedPost.propTypes = {
  post: PropTypes.shape({
    id: PropTypes.string.isRequired,
    puzzleId: PropTypes.string.isRequired,
    user: PropTypes.shape({
      id: PropTypes.string,
      username: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string,
    }).isRequired,
    imageUrl: PropTypes.string.isRequired,
    caption: PropTypes.string,
    likeCount: PropTypes.number,
    commentCount: PropTypes.number,
    timestamp: PropTypes.string.isRequired,
    isLiked: PropTypes.bool,
    isBookmarked: PropTypes.bool,
    gridSize: PropTypes.string,
  }).isRequired,
};

export default FeedPost;
